<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  <form #userForm="ngForm">
    <div class="form-container" style="padding-top: 10px;">
      <!-- Username -->
      <div *ngIf="!data.hideUsername">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>User ID</mat-label>
        <input matInput [(ngModel)]="userdata.userName" name="userName" required #userName="ngModel" autocomplete="off">
        <mat-error *ngIf="userName.invalid && userName.touched">Username is required</mat-error>
      </mat-form-field>
</div>
   <!-- Password -->
<div *ngIf="!data.hidePassword">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Password</mat-label>
    <input matInput [(ngModel)]="userdata.password" 
           name="password" required  
           [type]="showPassword ? 'text' : 'password'" 
           #password="ngModel"
           placeholder="Password">
    <!-- Eye icon for toggling password visibility -->
    <i class="eye-icon"
       (click)="togglePasswordVisibility()"
       [ngClass]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'">
    </i>
    <mat-error *ngIf="password.invalid && password.touched">Password is required</mat-error>
  </mat-form-field>
</div>

      <!-- First Name -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>First Name</mat-label>
        <input matInput [(ngModel)]="userdata.firstName" name="firstName" required #firstName="ngModel">
        <mat-error *ngIf="firstName.invalid && firstName.touched">First name is required</mat-error>
      </mat-form-field>

      <!-- Last Name -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Last Name</mat-label>
        <input matInput [(ngModel)]="userdata.lastName" name="lastName" required #lastName="ngModel">
        <mat-error *ngIf="lastName.invalid && lastName.touched">Last name is required</mat-error>
      </mat-form-field>

      <!-- Email -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="userdata.emailAddress" name="emailAddress" required email #emailAddress="ngModel">
        <mat-error *ngIf="emailAddress.invalid && emailAddress.touched">
          <span *ngIf="emailAddress.errors?.required">Email is required</span>
          <span *ngIf="emailAddress.errors?.email">Invalid email address</span>
        </mat-error>
      </mat-form-field>

      <!-- User Type -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>User Type</mat-label>
        <mat-select [(ngModel)]="userdata.userType" name="userType" required #userType="ngModel">
          <mat-option *ngFor="let userType of filteredUserTypes" [value]="userType.id">
            {{ userType.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="userType.invalid && userType.touched">User Type is required</mat-error>
      </mat-form-field>

    <!-- Primary Phone -->
<!-- Primary Phone -->
<!-- Primary Phone -->
<mat-form-field appearance="outline" class="full-width">
    <mat-label>Primary Phone</mat-label>
    <input matInput [(ngModel)]="userdata.primaryPhone" 
           name="primaryPhone" 
           [pattern]="phonePattern"  
           #primaryPhone="ngModel">
           
    <!-- Error messages for invalid format -->
    <mat-error *ngIf="primaryPhone.errors?.pattern && primaryPhone.touched">
      Enter a valid phone number (e.g., +1 949 609 1497)
    </mat-error>
  </mat-form-field>
  
  

      <!-- Title -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Title</mat-label>
        <input matInput [(ngModel)]="userdata.title" name="title">
      </mat-form-field>

      <mat-form-field *ngIf="userdata.userType !== 1" appearance="outline" class="full-width">
        <mat-label>Organizations</mat-label>
        <mat-select
          [(ngModel)]="userdata.organizations" 
          name="organizations"
          placeholder="Select Organization"
          multiple
          [required]="role !== 1"
          (selectionChange)="onSelectionChange()">
          <mat-option *ngFor="let org of organizations" [value]="org.id">
            {{ org.organizationName }}
          </mat-option>
        </mat-select>
        
        <mat-error *ngIf="userdata.organizations.length === 0">
          Please select at least one organization.
        </mat-error>
      </mat-form-field>
      
      
      
      <!-- Notes -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Notes</mat-label>
        <textarea matInput [(ngModel)]="userdata.notes" name="notes"></textarea>
      </mat-form-field>

      <!-- Status -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="userdata.status" name="status" required #status="ngModel">
            <mat-option *ngFor="let option of statusOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        <mat-error *ngIf="status.invalid && status.touched">Status is required</mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- <button mat-raised-button color="primary" (click)="onSave()" tabindex="-1" [disabled]="userForm.invalid">SAVE</button> -->
<button mat-raised-button color="primary"
        (click)="onSave()"
        tabindex="-1"
        [disabled]="userForm.invalid || isSaving">

  <ng-container *ngIf="!isSaving">SAVE</ng-container>
  <ng-container *ngIf="isSaving">
    {{ data.user ? 'Updating User...' : 'Creating User...' }}
  </ng-container>

</button>
  <button mat-raised-button mat-dialog-close (click)="onCancel()" tabindex="-1">CANCEL</button>
</mat-dialog-actions>
